import {
  START_LOAD_SHIFT_STATUS,
  SUCCESS_LOAD_SHIFT_STATUS,
  ERROR_LOAD_SHIFT_STATUS,
  START_LOAD_SHIFT_TRANSFER,
  SUCCESS_LOAD_SHIFT_TRANSFER,
  ERROR_LOAD_SHIFT_TRANSFER,
  RESET_IS_LOADED_SHIFT_TRANSFER,
  START_SEND_SHIFT_TRANSFER,
  SUCCESS_SEND_SHIFT_TRANSFER,
  ERROR_SEND_SHIFT_TRANSFER,
  SET_ERROR_SEND_SHIFT_TRANSFER_CONFLICT_DEVALUATION,
  RESET_ERROR_SEND_SHIFT_TRANSFER_CONFLICT_DEVALUATION,
  RESET_GET_AND_SEND_SHIFT_TRANSFER,
  START_LOAD_SHIFT_ACCEPTING,
  SUCCESS_LOAD_SHIFT_ACCEPTING,
  ERROR_LOAD_SHIFT_ACCEPTING,
  RESET_SHIFT_ACCEPTING,
  START_SEND_SHIFT_ACCEPTING,
  SUCCESS_SEND_SHIFT_ACCEPTING,
  ERROR_SEND_SHIFT_ACCEPTING,
} from 'store/actions/shift'

const initialShiftStatus = {
  plantId: null,
  status: null,
  canTransferShiftForcedReassignment: undefined,
  isLoading: false,
  isLoaded: false,
  isError: false,
}

const initialShiftTransfer = {
  data: {
    plantFullName: '',
    recipientEmployees: [],
    deviationEvents: [],
    otherEvents: [],
  },
  isLoading: false,
  isLoaded: false,
  isError: false,
}

const initialSendTransfer = {
  isLoading: false,
  isLoaded: false,
  isError: false,
  isConflict: false,
}

const initialShiftAccepting = {
  data: {
    plantFullName: '',
    senderEmployeeName: '',
    deviationEvents: [],
    otherEvents: [],
  },
  isLoading: false,
  isLoaded: false,
  isError: false,
}

const initialSendAccepting = {
  isLoading: false,
  isLoaded: false,
  isError: false,
}

const initialState = {
  status: initialShiftStatus,
  transfer: initialShiftTransfer,
  sendTransfer: initialSendTransfer,
  accepting: initialShiftAccepting,
  sendAccepting: initialSendAccepting,
}

const shift = (state = initialState, action) => {
  switch (action.type) {
    // --- Status ---
    case START_LOAD_SHIFT_STATUS:
      return {...state, status: {...state.status, isLoading: true, isLoaded: false, isError: false}}
    case SUCCESS_LOAD_SHIFT_STATUS: {
      const {plantId, status, canTransferShiftForcedReassignment} = action.data
      return {
        ...state,
        status: {
          ...state.status,
          plantId,
          status,
          canTransferShiftForcedReassignment,
          isLoading: false,
          isLoaded: true,
        },
        sendTransfer: {...state.sendTransfer, isLoaded: false},
        sendAccepting: {...state.sendAccepting, isLoaded: false},
      }
    }
    case ERROR_LOAD_SHIFT_STATUS:
      return {...state, status: {...state.status, isLoading: false, isError: true}}

    // --- Transfer (GET) ---
    case START_LOAD_SHIFT_TRANSFER:
      return {
        ...state,
        transfer: {...state.transfer, isLoading: true, isLoaded: false, isError: false},
      }
    case SUCCESS_LOAD_SHIFT_TRANSFER:
      return {
        ...state,
        transfer: {...state.transfer, data: action.data, isLoading: false, isLoaded: true},
      }
    case ERROR_LOAD_SHIFT_TRANSFER:
      return {...state, transfer: {...state.transfer, isLoading: false, isError: true}}

    case RESET_IS_LOADED_SHIFT_TRANSFER:
      return {...state, transfer: {...state.transfer, isLoaded: false}}

    // --- Send Transfer (POST) ---
    case START_SEND_SHIFT_TRANSFER:
      return {
        ...state,
        sendTransfer: {isLoading: true, isLoaded: false, isError: false},
      }
    case SUCCESS_SEND_SHIFT_TRANSFER:
      return {
        ...state,
        sendTransfer: {isLoading: false, isLoaded: true, isError: false},
      }
    case ERROR_SEND_SHIFT_TRANSFER:
      return {
        ...state,
        sendTransfer: {isLoading: false, isLoaded: false, isError: true},
      }
    case SET_ERROR_SEND_SHIFT_TRANSFER_CONFLICT_DEVALUATION:
      return {
        ...state,
        sendTransfer: {isLoading: false, isLoaded: false, isError: true, isConflict: true},
      }
    case RESET_ERROR_SEND_SHIFT_TRANSFER_CONFLICT_DEVALUATION:
      return {
        ...state,
        sendTransfer: {isLoading: false, isLoaded: false, isError: false, isConflict: false},
      }
    // TODO: Refactor to one action RESET_SHIFT_TRANSFER with payload 'transfer' | 'sendTransfer'
    case RESET_GET_AND_SEND_SHIFT_TRANSFER:
      return {...state, transfer: initialShiftTransfer, sendTransfer: initialSendTransfer}

    // --- Accepting ---
    case START_LOAD_SHIFT_ACCEPTING:
      return {
        ...state,
        accepting: {...state.accepting, isLoading: true, isLoaded: false, isError: false},
      }
    case SUCCESS_LOAD_SHIFT_ACCEPTING:
      return {
        ...state,
        accepting: {...state.accepting, data: action.data, isLoading: false, isLoaded: true},
      }
    case ERROR_LOAD_SHIFT_ACCEPTING:
      return {...state, accepting: {...state.accepting, isLoading: false, isError: true}}
    case RESET_SHIFT_ACCEPTING:
      return {...state, accepting: initialShiftAccepting}

    // --- Send Accepting (POST) ---
    case START_SEND_SHIFT_ACCEPTING:
      return {...state, sendAccepting: {isLoading: true, isLoaded: false, isError: false}}
    case SUCCESS_SEND_SHIFT_ACCEPTING:
      return {...state, sendAccepting: {isLoading: false, isLoaded: true, isError: false}}
    case ERROR_SEND_SHIFT_ACCEPTING:
      return {...state, sendAccepting: {isLoading: false, isLoaded: false, isError: true}}

    default:
      return state
  }
}

export default shift
